import { DatabaseReportViewModel } from '@ail/reports-api'
import { Matomo } from '../helpers/Matomo'
import ExcellentExport, { ConvertOptions } from 'excellentexport'
import { CellFormat } from 'excellentexport/dist/format'

export class Reports {
  public static exportDatabaseReport(report: DatabaseReportViewModel) {
    Matomo.pushEvent('DataProtection', 'Export', 'Report', report.id)
    const rows = report.data as unknown as Partial<Record<string, string | number>>[]
    const options: ConvertOptions = {
      openAsDownload: true,
      format: 'xlsx',
      filename: `report-${report.id}-${new Date().getTime()}`,
    }

    function getExcelColumnName(index: number) {
      let columnName = ''
      while (index >= 0) {
        columnName = String.fromCharCode((index % 26) + 65) + columnName
        index = Math.floor(index / 26) - 1
      }
      return columnName
    }

    const visibleColsKeys = report.fields.map((c) => c.name)

    const columnsToFormat = report.fields.reduce(
      (result: { type: 'date' | 'currency'; index: number }[], col, index) => {
        if (col.settings?.dateFormat) {
          result.push({ type: 'date', index })
        }
        if (col.settings?.isCurrency) {
          result.push({ type: 'currency', index })
        }
        return result
      },
      []
    )

    const rowsToExport = rows.map((r) => {
      const exportRow: (string | number | undefined)[] = []
      visibleColsKeys.forEach((k) => {
        exportRow.push(r[k])
      })
      return exportRow
    })

    rowsToExport.unshift(report.fields.map((c) => c.name))

    const pattern = /[:\\/?*[]/g

    const formatConfig: Record<'date' | 'currency', CellFormat> = {
      date: {
        type: ExcellentExport.cellTypes.DATE,
        pattern: ExcellentExport.cellPatterns.DATE,
      },
      currency: {
        type: ExcellentExport.cellTypes.NUMBER,
        pattern: ExcellentExport.cellPatterns.DECIMAL,
      },
    }

    const sheet = {
      name: report.name.replace(pattern, '').substring(0, 31),
      from: {
        array: rowsToExport,
        arrayHasHeader: true,
      },
      formats: columnsToFormat.map((col) => {
        return {
          range: `${getExcelColumnName(col.index)}2:${getExcelColumnName(col.index)}${rowsToExport.length + 1}`,
          format: formatConfig[col.type],
        }
      }),
    }
    ExcellentExport.convert(options, [sheet])
  }
}
